module.exports = __webpack_public_path__ + "static/media/people10.7b578ad5.jpeg";